import { render, staticRenderFns } from "./comProfire.vue?vue&type=template&id=6e5a1c08&scoped=true&"
import script from "./comProfire.vue?vue&type=script&lang=js&"
export * from "./comProfire.vue?vue&type=script&lang=js&"
import style0 from "./comProfire.vue?vue&type=style&index=0&id=6e5a1c08&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5a1c08",
  null
  
)

export default component.exports